import { z } from 'zod';
import { oneOf } from '../../navigation/searchParams';

/** The page's tab. */
export const evaluationSearch = z.object({
  tab: oneOf(['overview', 'abtests', 'feedback', 'failures']),
});
